import React from "react"
import cx from "classnames"
import styles from "./GridLinks.module.css"
import sellerAcademyIcon from "../../../images/gridLinks/sellerAcademy.svg"
import leadershipsIcon from "../../../images/gridLinks/leadershipsIcon.svg"
import reportsIcon from "../../../images/gridLinks/reportsIcon.svg"
import dataStoryTellingIcon from "../../../images/gridLinks/dataStoryTellingIcon.svg"
import sellerAcademyMobileIcon from "../../../images/gridLinks/selleryMobileIcon.svg"
import leadershipsMobileIcon from "../../../images/gridLinks/leadershipMobileIcon.svg"
import reportsMobileIcon from "../../../images/gridLinks/reportsMobileIcon.svg"
import dataStoryTellingMobileIcon from "../../../images/gridLinks/dataStoryTellingMobileIcon.svg"
import leftIcon from "../../../images/gridLinks/leftIcon.svg"
import Image from "next/image";
import Link from "next/link";

const GridLinks = () => {
    return(
        <div className={cx(styles.container, "d-flex", "align-items-center", "justify-content-center", "w-100")}>
            <div className={cx(styles.linksWrapper, "w-100")}>
                {/*======================== data story telling*/}
                <Link href="/customer-experience/" className={styles.link}>
                    <div className={cx(styles.iconWrapper, "d-flex align-items-end justify-content-center w-100 h-100")}>
                        <Image src={dataStoryTellingIcon} alt="data story telling" className="d-none d-lg-flex" />
                        <Image src={dataStoryTellingMobileIcon} alt="data story telling" className="d-flex d-lg-none" />
                    </div>
                    <div className={styles.linkTextWrapper}>
                        <span className={cx(styles.linkTextSpan, "d-flex align-items-center justify-content-center")}>گزارش تجربه مشتریان</span>
                        <Image src={leftIcon} alt="data story telling link" className="d-none d-lg-flex" />
                    </div>
                </Link>
                {/*======================== data story telling*/}

                {/*======================== data story telling*/}
                <Link href="https://careers.digikala.com/" className={styles.link}>
                    <div className={cx(styles.iconWrapper, "d-flex align-items-end justify-content-center w-100 h-100")}>
                        <Image src={reportsIcon} alt="data story telling" className="d-none d-lg-flex" />
                        <Image src={reportsMobileIcon} alt="data story telling" className="d-flex d-lg-none" />
                    </div>
                    <div className={styles.linkTextWrapper}>
                        <span className={cx(styles.linkTextSpan, "d-flex align-items-center justify-content-center")}>فرصت‌های شغلی</span>
                        <Image src={leftIcon} alt="digikala reports link" className="d-none d-lg-flex" />
                    </div>
                </Link>
                {/*======================== data story telling*/}

                {/*======================== data story telling*/}
                <Link href="/digikala-group/" className={styles.link}>
                    <div className={cx(styles.iconWrapper, "d-flex align-items-end justify-content-center w-100 h-100")}>
                        <Image src={leadershipsIcon} alt="data story telling" className="d-none d-lg-flex" />
                        <Image src={leadershipsMobileIcon} alt="data story telling" className="d-flex d-lg-none" />
                    </div>
                    <div className={styles.linkTextWrapper}>
                        <span className={cx(styles.linkTextSpan, "d-flex align-items-center justify-content-center")}>گروه دیجی‌کالا</span>
                        <Image src={leftIcon} alt="leader ship link" className="d-none d-lg-flex" />
                    </div>
                </Link>
                {/*======================== data story telling*/}

                {/*======================== data story telling*/}
                <Link href="/blogs/data-storytelling/" className={styles.link}>
                    <div className={cx(styles.iconWrapper, "d-flex align-items-end justify-content-center w-100 h-100")}>
                        <Image src={dataStoryTellingIcon} alt="data story telling" className="d-none d-lg-flex" />
                        <Image src={dataStoryTellingMobileIcon} alt="data story telling" className="d-flex d-lg-none" />
                    </div>
                    <div className={styles.linkTextWrapper}>
                        <span className={cx(styles.linkTextSpan, "d-flex align-items-center justify-content-center")}>داستان پردازی با داده</span>
                        <Image src={leftIcon} alt="seller academy link" className="d-none d-lg-flex" />
                    </div>
                </Link>
                {/*======================== data story telling*/}
            </div>
        </div>
    )
}

export default GridLinks